import FilterUtils from '@/shared/utils/filters';
import ContractRule from '@/domain/contract/entity/contract-rule.entity'

export default class Rules {
  readonly empty = [
    (value: string) => (!!value) || 'Campo obrigatório',
  ]

  readonly hasValue = [
    (value: boolean) => (value !== null) || 'Campo obrigatório',
  ]

  readonly arrayStringIsEmpty = [
    (value: Array<string>) => ((value !== null) && (value.length > 0)) || 'Campo obrigatório',
  ]

  readonly arrayIsEmpty = [
    (value: Array<any>) => ((value !== null) && (value.length > 0)) || 'Campo obrigatório',
  ]

  readonly value = [
    (value: string) => (!!value
      && parseFloat(value.replace(',', '.')) >= 0.00)
      || 'Valor deve ser maior que zero',
  ]

  readonly negative = [
    (value: string) => (!!value
      && parseFloat(value) > 0.0) || 'Valor deve ser maior que zero',
  ]

  readonly nonNegative = [
    (value: string) => (!!value
      && parseFloat(value) >= 0.0) || 'Valor deve ser maior ou igual a zero',
  ]

  readonly negativeFinalQuantity = [
    (value: string) => ((!!value
      && parseFloat(value) > 0.0) || value === 'Infinito') || 'Valor deve ser maior que zero',
  ]

  readonly minimumValueTwo = [
    (value: string) => (!!value && parseFloat(value) >= 2.0) || 'Valor mínimo é dois',
  ]

  readonly minimumValueOne = [
    (value: string) => (!!value && parseFloat(value) >= 1.0) || 'Valor mínimo é um',
  ]

  readonly moneyBiggerThanZero = [
    (value: string) => (!!value
      && (Number(FilterUtils.formatValue(`${value}`))) > 0.0) || 'Valor deve ser maior que zero',
  ]

  readonly moneyEqualOrBiggerThanZero = [
    (value: string) => (!!value
      && (Number(FilterUtils.formatValue(`${value}`))) >= 0.0)
      || 'Valor deve ser igual ou maior que zero',
  ]

  readonly money2BiggerThanZero = [
    (value: string) => (!!value
      && (Number(FilterUtils.formatValue(`${value}`))) > 0.0000)
      || 'Valor deve ser maior que zero',
  ]

  readonly money2EqualOrBiggerThanZero = [
    (value: string) => ((!!value
      && (Number(FilterUtils.formatValue(`${value}`))) >= 0.0000)) || (!(value))
      || 'Valor deve ser igual ou maior que zero',
  ]

  readonly betweenZeroAndOneHundred = [
    (value: string) => (!!value
      && (Number(FilterUtils.formatValue(`${value}`))) >= 0.0
      && (Number(FilterUtils.formatValue(`${value}`))) <= 100.0)
      || 'Valor deve ser entre 0 (zero) e 100 (cem)',
  ]

  readonly greaterThanZero = [
    (value: string) => (!!value
      && (Number(FilterUtils.formatValue(`${value}`))) >= 0.0)
      || 'Valor deve ser entre 0 (zero) e 100 (cem)',
  ]

  readonly betweenMinusHudredAndHundred = [
    (value: string) => (!!value
      && (Number(FilterUtils.formatValue(`${value}`))) >= -100.0
      && (Number(FilterUtils.formatValue(`${value}`))) <= 100.0)
      || 'Valor deve ser entre -100 (menos cem) e 100 (cem)',
  ]

  readonly ruleNotEmpty = [
    (value: ContractRule) => (!!value
        && value.parameters.length !== 0
        && value.id !== '') || 'Campo Obrigatório',
  ]

  readonly fieldValuesMaxSize300 = [
    (value: string) => (!!value
      && (Number(FilterUtils.formatValue(`${value.length}`)) <= 300.0))
      || 'O campo deve ter no máximo 300 caracteres',
  ]

  readonly username = [
    (value: string) => {
      if (!value) return true;
      if (value.includes(' ')) {
        return 'Não deve haver espaços em branco';
      }
      return !value.includes('@') || 'Apenas o conteúdo antes do @ deve vir aqui';
    },
  ]

  readonly minLength = (min: number) => [
    (value: string) => {
      if (!value) return 'Campo obrigatório';
      return value.trim().length >= min || `O campo deve ter pelo menos ${min} caracteres`;
    },
  ]
}
